import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { accountSettingsAPI } from 'services/accountSettings.service';
import { saveLocalStorageItem } from 'utils';
import { authActions } from 'store/auth/auth';
import { Loader } from 'components';
import styled from 'styled-components';
import { Palette } from 'config';

const EmailValidatePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [validateNewEmailAddress, result] = accountSettingsAPI.useValidateNewEmailAddressMutation();
  const [searchParams] = useSearchParams();
  const timer = useRef(null);
  const loaded = useRef(false);

  const id = searchParams.get('id');

  useEffect(() => {
    if (loaded.current) return;
    loaded.current = true;
    validateNewEmailAddress({ id });
  }, [id]);

  useEffect(() => {
    if (result && result.isSuccess) {
      // logout and redirect user to login page after 5s
      saveLocalStorageItem({
        key: 'tableState',
        field: 'filteredCampaigns',
        value: [],
      });
      dispatch(authActions.clearAuthState());
      timer.current = setTimeout(() => {
        navigate('/userLogin');
      }, 5000);
    }

    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, [result]);

  const isSuccess = loaded?.current && result?.isSuccess && !result?.isError;
  const errorMessage =
    result?.error?.data?.Message ||
    result?.error?.data?.message ||
    result?.error?.message ||
    'Error while saving new email';

  if (result.isLoading && !result?.isError && !result?.isSuccess)
    return <Loader.Global delay={100} />;

  return (
    <>
      {/* {isError && <ErrorComponent />} */}
      <Header>Email Validate</Header>
      <Wrap>
        <div style={{ gridArea: 'main' }}>
          {isSuccess
            ? 'Email validate sucessfully. You will be redirected to login page in 5s.'
            : errorMessage}
        </div>
        <div style={{ gridArea: 'sidebar' }}>{/* <RecommendationsFloatingSideBar /> */}</div>
      </Wrap>
    </>
  );
};

const Header = styled.div`
  display: flex;
  flex: 0 0 100%;
  max-width: 964px;
  padding: 48px 0;
  margin: 0 auto;
  font-size: 40px;
  color: ${Palette.PrimaryGray._900};
  font-weight: 700;
  line-height: 48px;
  letter-spacing: -0.8px;
`;

const Wrap = styled.div`
  display: grid;
  grid-template-columns: 964px 200px;
  width: 964px;
  gap: 32px;
  margin: auto;
  margin-bottom: 50px;
  grid-template-rows: auto;
  grid-template-areas: 'main sidebar';
  color: ${Palette.PrimaryGray._900};
`;

export default EmailValidatePage;
